import React, { useEffect, useRef, useState } from "react";
import "./BannerSlider.css";
import { db } from "../firebase/firebase";
import { collection, query, orderBy, limit, onSnapshot } from "firebase/firestore";

const defaultImages = [
  // "/images/banner1.jpg",
  // "/images/banner2.jpg",
  // "/images/banner3.jpg",
  // "/images/banner4.jpg",
  // "/images/banner5.jpg",
];

export default function BannerSlider({ images: propImages }) {
  const [images, setImages] = useState(propImages && propImages.length ? propImages : defaultImages);
  const [index, setIndex] = useState(0);
  const intervalRef = useRef(null);

  useEffect(() => {
    // subscribe to Firestore `banners` collection to get admin-uploaded banners
    try {
      const bannersRef = collection(db, "banners");
      const q = query(bannersRef, orderBy("createdAt", "desc"), limit(6));
      const unsub = onSnapshot(q, (snap) => {
        const imgs = snap.docs
          .map(d => d.data()?.imageUrl)
          .filter(Boolean);
        if (imgs && imgs.length > 0) setImages(imgs);
      }, (err) => {
        console.error('Banner snapshot error', err);
      });
      return () => unsub();
    } catch (err) {
      // if firebase isn't configured in some environments, keep defaults
      console.warn('BannerSlider Firestore load skipped', err);
    }
  }, []);

  useEffect(() => {
    startAutoRotate();
    return () => stopAutoRotate();
  }, [images]);

  const startAutoRotate = () => {
    stopAutoRotate();
    if (!images || images.length === 0) return;
    intervalRef.current = setInterval(() => {
      setIndex(i => (i + 1) % images.length);
    }, 3500);
  };

  const stopAutoRotate = () => {
    if (intervalRef.current) {
      clearInterval(intervalRef.current);
      intervalRef.current = null;
    }
  };

  const goPrev = () => {
    if (!images || images.length === 0) return;
    setIndex(i => (i - 1 + images.length) % images.length);
    startAutoRotate();
  };

  const goNext = () => {
    if (!images || images.length === 0) return;
    setIndex(i => (i + 1) % images.length);
    startAutoRotate();
  };

  const currentSrc = (images && images.length) ? images[index % images.length] : defaultImages[0];

  return (
    <section className="homepage-banner-section">
      <div
        className="banner-wrapper"
        onMouseEnter={stopAutoRotate}
        onMouseLeave={startAutoRotate}
      >
        <img
          src={currentSrc}
          alt={`Banner ${index + 1}`}
          className="banner-img"
          draggable="false"
          onError={(e) => { e.target.onerror = null; e.target.src = defaultImages[0]; }}
        />

        <button
          className="banner-arrow banner-arrow-left"
          onClick={goPrev}
          aria-label="Previous banner"
        >
          ‹
        </button>

        <button
          className="banner-arrow banner-arrow-right"
          onClick={goNext}
          aria-label="Next banner"
        >
          ›
        </button>

        <div className="banner-wave" aria-hidden="true">
          <svg viewBox="0 0 1440 320" preserveAspectRatio="none">
            <path fill="#ffffff" fillOpacity="1" d="M0,64L60,80C120,96,240,128,360,144C480,160,600,160,720,154.7C840,149,960,139,1080,128C1200,117,1320,107,1380,101.3L1440,96L1440,320L1380,320C1320,320,1200,320,1080,320C960,320,840,320,720,320C600,320,480,320,360,320C240,320,120,320,60,320L0,320Z"></path>
          </svg>
        </div>
      </div>
    </section>
  );
}
